import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import ErrorIcon from '../../../assets/images/icon_error_messages.gif';
import Label from './common/label';

const Contact = ({ labels, errors, touched }) => {
  return (
    <>
      <Label labelName={labels.CONTACT_NUMBER} />
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.contactNumber && touched.contactNumber ? 'error' : ''
        }`}
      >
        <Field
          placeholder={labels.CONTACT_NUMBER}
          name="contactNumber"
          className="select-style"
          type="text"
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.contactNumber}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </>
  );
};

Contact.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired
};

export default Contact;
